import { SegmentWithHeader } from '@app/shared';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';
import { Merchant } from '@app/models';
import { AggregatedConfigurations } from '../products/AggregatedConfigurations';
import { ComponentErrorBoundary } from '@app/utilities';

export function MerchantDetail({ merchant }: { merchant: Merchant }) {
  return merchant ? (
    <ComponentErrorBoundary>
      <SegmentWithHeader header={`Merchant: ${merchant.merchantId}`} className={'basic'}>
        <ScrollableContentContainer className={'basic'} height={'150px'} style={{ border: 'thin solid lightgray' }}>
          <JsonViewer value={merchant} />
        </ScrollableContentContainer>
      </SegmentWithHeader>
      <SegmentWithHeader className={'basic'} header={`Aggregated Configurations`}>
        <ScrollableContentContainer height={'350px'}>
          <AggregatedConfigurations ouId={merchant.organisationUnitId} category="Merchant" />
        </ScrollableContentContainer>
      </SegmentWithHeader>
    </ComponentErrorBoundary>
  ) : (
    <div>Merchant not found.</div>
  );
}
